module.exports = __webpack_public_path__ + "img/47.5f43faa4.jpg";